import { useRef } from 'react';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { FILE_INPUT_TEST_ID, TEST_ID } from './constants';
import type { FileInputChangeEvent, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DropZone: FunctionComponent<Props> = ({
    acceptFileTypes,
    className = '',
    ctaText,
    formatsText,
    isProcessing,
    onFilesSelected,
    testId = TEST_ID
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        if (isProcessing) {
            return;
        }
        inputRef.current?.click();
    };

    const handleInputChange = (event: FileInputChangeEvent) => {
        const files = event.target.files ? Array.from(event.target.files) : [];

        event.target.value = '';
        onFilesSelected({ files });
    };

    const processingClass = isProcessing ? styles.dropZoneProcessing : '';

    return (
        <VerticalContainer
            className={`${className} ${processingClass} ${styles.dropZone}`}
            onClick={handleClick}
            testId={testId}>
            <input
                accept={acceptFileTypes}
                className={styles.hiddenInput}
                data-testid={FILE_INPUT_TEST_ID}
                multiple
                onChange={handleInputChange}
                ref={inputRef}
                type='file'
            />

            <Wrapper className={styles.dropZoneIcon}>{'\u2191'}</Wrapper>

            <Wrapper className={styles.dropZoneCta}>{ctaText}</Wrapper>

            <Wrapper className={styles.dropZoneFormats}>{formatsText}</Wrapper>
        </VerticalContainer>
    );
};

export default DropZone;
